module.exports = __webpack_public_path__ + "assets/5c5c22d24eb86bbd6eb33d825ed66058.json";